'use strict';

const EventEmitter = require('events');

import BuiltinRepository from './repository/BuiltinRepository';
import FacetRepository from './repository/FacetRepository';
import GoogleMap from './map/GoogleMap';
import OpenLayerMap from './map/OpenLayerMap';
import PopupFactory from './PopupFactory';
import Controller from './Controller';
import PlaceType from './PlaceType';
import Request from './Request';

const IHGeolocation = require('ih/ih.geolocation');

/**
 * @name IHOptions
 * @type {Object}
 * @property {GoogleMapOptions|OpenLayerMapOptions} mapOptions
 * @property {BuiltinRepositoryOptions|FacetRepositoryOptions} repositoryOptions
 * 
 */

/**
 * @class IH
 *
 * events:
 *   ihClickMarker      マーカークリック時
 *   ihUpdateCenterMarker 基準位置移動時
 *   ihReady (or ready) start()完了後
 *   ihClear            clear()実行後
 *   ihBeforeRequestPlaces すべてのマーカー配置前
 *   ihAfterRequestPlaces  すべてのマーカー配置後
 *   ihBeforeSearch     検索APIのアクセス前
 *   ihAfterSearch      検索APIのアクセス後
 *   ihFillMarkerPopup  マーカーのInfoWindowのDOM構築後
 *   ihFillSearchResult 結果リストの１項目のDOM構築後
 *   
 */
class IH {
  /**
   * 
   * @access public
   * @param {IHOptions} options
   * @returns void
   */
  constructor(options) {
    
    var vars = this.getProperties();
    for (var i in vars) {
      this[i] = vars[i];
    }
    
    if (console) {
      console.log(options);
    }
    // モジュールを読み込む
    if (options['modules']) {
      this.modules = options['modules'];
      delete options['modules'];
    }
    // モジュールを読み込む（modulesを上書きせずに差分のみ指定したい場合）
    if (options['modules_append']) {
      this.modules = this.modules.concat(options['modules_append']);
      delete options['modules_append'];
    }
    this.extendModules(options);

    // モジュールを読み込んだ後に、変数を設定する
    // モジュールの初期値を上書きできるようにするため
    this.setOptions(options);
    
    this.createController(options).apply(this);
  }
  /**
   * 
   * @returns {Controller}
   */
  createController(options) {
    return new Controller(options);
  }
  /**
   * インスタンス変数
   * 
   */
  getProperties() {
    return {
      /**
       * @type {boolean}
       */
      debug: false,
      /**
       * @vars {{lat: Number, lng: Number}}
       */
      init_location: {lat: 34.846142, lng: 135.617251},
      /**
       * 施設情報。initializeでHTML(#facility_list)の情報を読み取る
       */
      flag_display_facility: [], // [0]: 緊急避難所
      /**
       * マーカーの画像パス
       * @type {string}
       */
      icon_file_path: 'img/',
      /**
       * 施設画像のパス
       */
      place_image_path: '',
      /**
       * デフォルトのマーカー画像
       */
      icon_default: 'img/default_min.png',
      /**
       * 選択中の半径
       * @access protected
       * @type String
       */
      selected_radius: "0.5",
      /**
       * @type {IHModule[]}
       */
      modules: [
        IHGeolocation
      ],
      lastClickedPlace: null,
      /**
       * 検索時に基準位置を移動させるかどうか
       * @type Boolean
       */
      updateBaseMarker: false,
      /**
       * マーカークリック時にパネルを表示するかどうか
       */
      show_detail_panel: null,
      /**
       * 施設タイプの定義
       * @type {[type]}
       */
      placeTypes: null,
      /**
       * サービス
       */
      services: {},
      /**
       * サービスプロバイダ
       */
      serviceProvider: {
        // map: {
        //   Elevation: google.maps.ElevationService,
        //   Direction: google.maps.DirectionsService
        // },
        // get: function(name) {
        //   return new this.map[name]();
        // }
      },
      searchResultOffset: 0,
      searchResultLimit: 30,
      searchResultPlaces: null,
      
      repositoryOptions: {
        type: 'builtin',
        searchApi: 'search'
      },
      mapOptions: {
        type: 'openlayer',
        outer_frame_selectors: ['#header', '#footer'],
        container_selector: "#main",
        gmap_selector: '#gmap',
        gmap_options: {},
        // gmap_options_default: typeof google === 'undefined' ? {} : {
        gmap_options_default: {
          zoom: 17, // 初期ズームレベル
          minZoom: 17,
          maxZoom: 19
          // mapTypeId: google.maps.MapTypeId.ROADMAP,
          // mapTypeId: google.maps.MapTypeId.TERRAIN,
          // mapTypeId: google.maps.MapTypeId.SATELLITE,
          // panControlOptions: {
          //   position: google.maps.ControlPosition.LEFT_TOP
          // },
          // zoomControlOptions: {
          //   position: google.maps.ControlPosition.LEFT_TOP
          // }
          /*
           panControl: false

           streetViewControl: false // 実験時は未使用

           disableDefaultUI: true, // 全てのパネル（拡大，ストリートビュー）を非表示にする

           mapTypeControl: true, // マップタイプコントローラを表示する
           mapTypeControlOptions: {
           //position: this.gcp.LEFT_CENTER
           position: this.gcp.LEFT_TOP
           },

           zoomControl: true, // ズームコントローラを表示する
           zoomControlOptions: {
           //position: this.gcp.LEFT_BOTTOM
           position: this.gcp.LEFT_TOP
           },

           streetViewControl: true,
           streetViewControlOptions: {
           position: this.gcp.RIGHT_BOTTOM
           },
           */
        }
      }
    };
    
  }
  getService(name){
    if (!this.services[name]){
      this.services[name] = this.serviceProvider.get(name);
    }
    return this.services[name];
  }
  /**
   * モジュールを読み込む
   * ・IHのprototypeを上書きする（後者優先のオーバーライド。coreすらも上書きする）
   * ・各モジュールの extended メソッドを呼ぶ
   * 
   * @returns {undefined}
   */
  extendModules() {
    var that = this;
    $.each(this.modules, function(i, module){
      if (typeof module === 'string'){
        if (window[module]){
          module = window[module];
        }else{
          console.warn('undefined module:' + module);
          return;
        }
      }
      $.extend(IH.prototype, module.prototype);
      module.extended(that);
    });
  }
  
  /**
   * 
   * @access public
   * @param {Object} options
   * @returns void
   */
  setOptions(options){
    options = options || {};

    for (var key in options) {
      if (typeof this[key] !== 'undefined') {
        this[key] = options[key];
      }
    }
    
    if (options.polygonTypes) {
      this.setOptionsForPolygons(options.polygonTypes);
    }
    if (options.placeTypes) {
      this.setOptionsForPlaceTypes(options.placeTypes);
    }

  }
  setOptionsForPolygons(polygonTypes) {
    // optionsから初期データの設定
    if (polygonTypes.landslide) {
      this.landslide_bool = {};
      this.landslide_filename_table = [];
      this.flag_display_landslide = [];

      for (var id in polygonTypes.landslide) {
        var d = polygonTypes.landslide[id];
        this.landslide_filename_table.push(id);
        this.flag_display_landslide.push(false);
        this.landslide_bool[id] = 0;
      }
    }
    if (polygonTypes.river) {
      this.river_bool = {};
      this.river_name_table = {};
      for (var id in polygonTypes.river) {
        var d = polygonTypes.river[id];
        this.river_bool[id] = 0;
        this.river_name_table[id] = d.name;
      }
    }
  }
  setOptionsForPlaceTypes(placeTypes) {
    this.flag_display_facility = [];
    for (var i = 0; i < placeTypes.length; i++) {
      var place = placeTypes[i];

      this.flag_display_facility.push(place.checked);
    }
    // placeTypeは他のオブジェクトにも共有しているので、差し替えできるように専用のメソッド経由で破壊的に行う
    if (this.placeType) {
      this.placeType.reset(placeTypes, {
        icon_default: this.icon_default,
        icon_file_path: this.icon_file_path
      });
    } else {
      this.placeType = new PlaceType(placeTypes, {
        icon_default: this.icon_default,
        icon_file_path: this.icon_file_path
      });
    }
  }
  /**
   * 
   * @access  public
   * @returns {Promise}
   */
  reset(){
    this.mapEvents = new EventEmitter();
    this.mapEvents.on('ihClickMarker', (place, marker, popup) => {
      $(this).trigger('ihClickMarker', [place, marker, popup]);
    });
    this.mapEvents.on('ihFillMarkerPopup', (place, popup) => {
      $(this).trigger('ihFillMarkerPopup', [place, popup]);
    });
    this.popupFactory = new PopupFactory({
      place_image_path: this.place_image_path,
      placeType: this.placeType,
      mapEvents: this.mapEvents
    });

    this.repositoryEvents = new EventEmitter();
    this.repositoryEvents.on('ihBeforeSearch', (request) => {
      $(this).trigger('ihBeforeSearch', [request]);
    });
    this.repositoryEvents.on('ihAfterSearch', (request, response) => {
      $(this).trigger('ihAfterSearch', [request, response]);
    });
    
    this.repository = this.createRepository(this.repositoryOptions);
    this.repository.setEvents(this.repositoryEvents);

    this.map = this.createMap(this.mapOptions);
    this.map.reset();

    this.geocoder = this.createGeocoder();

    return Promise.resolve();
  }
  createGeocoder() {
    if (typeof google !== 'undefined') {
      return new google.maps.Geocoder();
    } else {
      return null;
    } 
  }
  /**
   * 
   * @param options
   * @returns {Map}
   */
  createMap(options) {
    if (options.type === 'googlemap') {
      return new GoogleMap(this.mapEvents, this.popupFactory, this.placeType, options);
    } else if (options.type === 'openlayer') {
      return new OpenLayerMap(this.mapEvents, this.popupFactory, this.placeType, options);
    }
    throw new Error('unknown map: ' + options.type);
  }
  /**
   * 
   * @param options
   * @returns {Repository}
   */
  createRepository(options) {
    if (options.type === 'builtin') {
      return new BuiltinRepository(options);
    } else if (options.type === 'facet') {
      return new FacetRepository(options);
    }
    throw new Error('unknown repository: ' + options.type);
  }
  /**
   * 初期位置を取得
   * 
   * @returns {google.maps.LatLng}
   */
  getInitLocation(){
    return this.map.createLatLng(this.init_location.lat, this.init_location.lng);
  }
  /**
   * @access  public
   * @returns void
   * 
   * ハザードマップを開始する。HTMLのロード後に実行すること
   * @return Promise
   */
  start() {
    return Promise.resolve()
      .then(() => this.reset())
      .then(() => this.beforeStart())
      .then(() => this._start())
      .then(() => this.afterStart())
  }
  /**
   * モジュール上書き用
   * 
   * @protected
   * @return Promise
   */
  beforeStart() {
    return Promise.resolve();
  }
  /**
   * モジュール上書き用
   *
   * @protected
   * @return Promise
   */
  afterStart() {
    return Promise.resolve();
  }
  /**
   *
   * @private
   * @return Promise
   */
  _start() {
    
    this.map.start();

    var that = this;

    // 既定のハンドラー（ここはモジュール読み込み後に実行されるので最後になるのかも？）
    $(this).on('ihClickMarker', (event, place, marker, popup) => {
      this.clickMarkerHandler(event, place, marker, popup);
    });
    $(this).on('ihClickMarker', function(event, place, marker, popup){
      that.lastClickedPlace = place;
    });

    $(this).on('ihAfterRequestPlaces', function(event, request, places){
      that.displaySearchResult(places);
      that.map.displayMarkers(request, places);
      this.displayLoading(false);
  
      // 検索後、ファセット値の選択を有効化
      $('.js-facet-selector').each(function () {
        $(this).prop('disabled', false);
      });
      
    });
    $(this).on('ihBeforeRequestPlaces', function(event, request){
  
      // 検索開始時、ファセット値の選択を無効化（ファセット値連打防止）
      $('.js-facet-selector').each(function () {
        $(this).prop('disabled', true);
      });
      
      that.clear();
      this.displayLoading(true);
    });

    $(this).on('ihReady', function(event){
      that.ready();
    });
    $('.sr-next').on('click', function(){
      that.showNextSearchResult();
    });

    /**
     * @event IH.ready
     */
    $(this).trigger('ihReady');
    $(this).trigger('ready'); // backward compatibility

    // ready直後に動作
    // show_*等実行させるため、次のターンで

    // TODO setloc_placeは_searchのあとで基準位置を更新してるので、確実にその後に実行できるようにしたい
    // firstActionを配列でasync.seriesで実行できれば...
    setTimeout(function(){
      that.firstAction();
    }, 1000);
    
    return Promise.resolve()
    
  }
  ready(){
    var that = this;
    
    // ------------------------------------
    // サイズ調整
    this.map.adjustMapSize();
    $(window).bind("resize", (event) => {
      this.map.adjustMapSize(event);
    });

    this.map.setCenterAndCurrentLocation(this.getInitLocation());
    
    // マーカーを表示せずに位置だけ指定
    // app?setloc_place=123
    var qs = this.getQueryString();
    var place = qs.setloc_place;
    if (place){
      var params = {places: [place], origin: 'system'};
      this._search(new Request(params)).then(function(res){
        if (res.places && res.places.length > 0){
          let latlng = this.map.createLatLng(res.places[0].lat, res.places[0].lng);
          that.map.setCenter(latlng);
          that.map.updateCurrentLocation(latlng);
        }
      });
    }else{
      // app?setloc_lat=35&setloc_lng=135
      // 中心を初期座標に合わせる
      // QueryStringから座標を取得
      var lat = qs.setloc_lat;
      var lng = qs.setloc_lng;

      if (lat && lng){
        lat = lat.replace("#", "");
        lng = lng.replace("#", "");

        if (parseInt(lat, 10) > 30 && parseInt(lng, 10) > 130) {
          // QueryStringでの初期位置指定がある場合
          let latlng = this.map.createLatLng(lat, lng);
          that.map.setCenter(latlng);
          that.map.updateCurrentLocation(latlng);
        }
      }

    }

  }
  /**
   * 既定のマーカークリック動作
   * 
   * @access protected
   * @param event
   * @param place
   * @param marker
   * @param popup
   */
  // clickMarkerHandler(event, place, marker, popup) {
  //   this.map.toggleMarkerPopup(marker, popup);
  // }
  /**
   * v3.3から、高低差表示すると、選択したマーカーとパネルの情報があわなくなってしまった。そのため、常に選択したマーカーとパネルは同期するように変更
   *
   * v3.2までのフロー
   *
   * 0. 表示なし
   *  |
   *  | ＜マーカークリック or パネル等のクリック＞
   *  v
   * 1. マーカー表示
   *  |
   *  |------------＜マーカークリック＞---> 0.へ【未実装: パネル等のクリックは2になるようにしたい】
   *  |
   *  | ＜マーカー or ポップアップクリック or パネル等のクリック＞
   *  v
   * 2. マーカー表示 + パネル表示
   *
   * @param {type} event
   * @param {type} place
   * @param {type} marker
   * @param {type} popup
   */
  clickMarkerHandler(event, place, marker, popup) {

    if (!this.map.isOpenMarkerPopup(popup)) {
      if (this.show_detail_panel) {
        this.openInfoPanel(place);
      } else {
        this.closeInfoPanel(place);
      }
    }

    this.map.toggleMarkerPopup(marker, popup);

    $(popup).on('click', () => {
      this.openInfoPanel(place);
    });

  }
  /**
   * パネルを開き、施設の詳細を表示する
   *
   * @param {type} place
   * @returns {undefined}
   */
  openInfoPanel(place) {
    var latlng = this.map.createLatLng(place.lat, place.lng);
    // this.map.setCenter(latlng);
  
    ga('send', {
      hitType: 'event',
      eventCategory: '詳細パネル',
      eventAction: '詳細パネルを開く',
      eventLabel: place.name
    });
    
    // TODO: セレクタはオプションにするか拡張でやりたい。Controllerでやるべき？
    $('#page-place').panel('open');
    $('#page-place').data('place-id', place.id); // for tracking
    this.popupFactory.fillMarkerPopup(place, $('#page-place'));
  }
  closeInfoPanel(place) {
    // TODO: セレクタはオプションにするか拡張でやりたい。Controllerでやるべき？
    // パネルを閉じる
    $('.ui-panel').panel('close');
  }
  /**
   * util
   * URLのQueryStringを取得し，連想配列で返す
   * 
   * @returns {Object}
   */
  getQueryString() {
    /**
     *
     * http://phpspot.org/blog/archives/2009/09/jqueryquerystri.html
     */
    var vars = {}, hash;
    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for (var i = 0; i < hashes.length; i++) {
      hash = hashes[i].split('=');
//      vars.push(hash[0]);
      vars[hash[0]] = hash[1];
    }
    return vars;
  }
  
  /**
   * 座標から住所を取得する
   * 
   * @uses geocoder
   * 
   * @param {type} latlng
   * @param {type} callback
   * @returns {undefined}
   */
  getAddress(latlng, callback) {
    if (this.geocoder) {
      this.geocoder.geocode({'latLng': latlng, 'language': 'ja'}, function(results, status) {
        if (status == google.maps.GeocoderStatus.OK) {
          if (results[1]) {
            callback(results[1].formatted_address);
          }
        }
      });
    }
  }
  
  displayLoading(bool_loading) {
    if (bool_loading){
      $.mobile.loading( 'show', {
          textVisible: false,
          theme: "a",
          textonly: false
      });
    }else{
      $.mobile.loading( "hide" );
    }
  }

  getSearchTargetTypes() {
    /**
     * 検索対象となっている施設の番号を得る
     * 形式：ハイフン区切り（ex. 1-2-3）
     */
    var types = [];

    for (var i = 0, len = this.flag_display_facility.length; i <= len; i++) {
      if (this.flag_display_facility[i]) {
        types.push(i);
      }
    }
    
    return types;
  }
  /**
   * 検索等で変更された状態を初期状態に戻す
   * 
   * @returns {undefined}
   */
  clear(){
    this.map.clearMarkersAll();
    this.clearSearchResult();
    this.map.displayCircle(0);
    $(this).trigger('ihClear');
  }
  

  fillUrls(urls, tpl){
    tpl.hide();
    var parent = tpl.parent();
    parent.find('.real-link').remove();
    
    for (var i = 0; i < urls.length; i++){
      parent.append(
        tpl.clone().attr('href', urls[i].url).text(urls[i].label).addClass('real-link').show()
      );
      parent.append(document.createTextNode(' '));
    }
  }
  parseUrl(str){
    var ret = [];
    var list = str.split(/\s*\|\s*/);
    var m, index;
    for (var i = 0; i < list.length; i++){
      m = list[i].match(/https?:\/\/.*/);
      if (!m){
        continue;
      }
      index = list[i].indexOf(m);
      if (index === 0){
        ret.push({label: m[0], url: m[0]});
      }else{
        ret.push({label: list[i].substr(0, index).trim(), url: m[0]});
      }
    }
    return ret;
  }
  getLastClickedPlace(){
    return this.lastClickedPlace;
  }
  clearSearchResult(){
    var tpl = $('.sr-template');
    var container = $(".sr-container");
    container.empty();
    container.append(tpl);
  }
  /**
   * 検索結果リストを表示
   * 
   * @param {type} json
   * @returns void
   */
  displaySearchResult(places) {
    /*
     * 検索結果リストを表示
     */
    this.clearSearchResult();
    this.searchResultOffset = 0;
    this.searchResultPlaces = places;
    
    var that = this;

    if (places.length == 0){
      $('.sr-notfound').show();
      return;
    }
    $('.sr-notfound').hide();
      
    if (places.length > this.searchResultLimit){
      $('.sr-next').show();
    }else{
      $('.sr-next').hide();
    }

    var placesRanged = places.slice(this.searchResultOffset, this.searchResultLimit);

    $.each(placesRanged, function(i, place){
      if (!place) return;
      that.displaySearchResultRow(place);
    });
  }
  showNextSearchResult(){
    var that = this;
    var places = that.searchResultPlaces;
    var offset = that.searchResultOffset = that.searchResultOffset + that.searchResultLimit;
    var limit = that.searchResultLimit;

    if (places.length >= offset + limit){
      $('.sr-next').show();
    }else{
      $('.sr-next').hide();
    }

    var placesRanged = places.slice(offset, offset + limit);
    $.each(placesRanged, function(i, place){
      if (!place) return;
      that.displaySearchResultRow(place);
    });
  }
  displaySearchResultRow(place){
    var that = this;
    var container = $(".sr-container");
    var tpl = $('.sr-template');

    var t = tpl.clone().removeClass('sr-template').show();
    t.addClass('place-id-' + place.id); // 施設選択状態の見た目を変更するなどに使用する
    // t.find('.sr-img').attr('src', this.placeType.getTypeIcon(place.type));
    t.find('.sr-img').attr('src', '../sites/tennoji-zoo/assets/img/pin/' + place.type + '_ico.png');
      
    t.find('.sr-name').text(place.name);
    // t.find('.sr-type').text('（' + this.placeType.getName(place.type) + '）');
    t.find('.sr-type').text('（' + place.attributes['綱'] + '）');
    
    t.find('.sr-link').on('click', function(){
      t.siblings().removeClass('js-selected');
      t.addClass('js-selected');
      // that.map.focusMarker(place.id, place.lat, place.lng);
      var latlng = that.map.createLatLng(place.lat, place.lng);
      that.map.setCenter(latlng);
      that.map.focusMarker(place);
    });
    if (typeof place.distance !== 'undefined'){
      t.find('.sr-distance').text(Math.ceil(place.distance.toFixed(2) * 1000) + "m");
    }
    $(that).trigger('ihFillSearchResult', [place, t]);
    container.append(t);
  }
  // filter
  // 元のデータに空を意味する "-" が含まれるので除去
  placeDataFilter(place){
    for (var k in place){
      if (typeof place[k] === 'string'){
        place[k] = place[k].replace(/^-$/, '');
      }
    }
    return place;
  }
  /**
   * 施設やポリゴンデータを検索する
   * 
   * @param {Request} request
   * @returns {jQuery.Deferred}
   */
  _search(request) {
    
    return this.repository.search(request);
    
  }
  /**
   * 座標位置や特定の施設IDなどから、検索を実行し、結果を返す
   * 
   * @param {type} params
   * @return {jQuery.Deferred}
   */
  requestPlaces(params){
    var that = this;
    if (this.updateBaseMarker && params.lat && params.lng){
      this.map.updateCurrentLocation(params.lat, params.lng);
    }
    
    if (!params.origin){
      params.origin = 'user';
    }
    if (!params.latlng){
      params.latlng = this.map.getCurrentSearchLocation();
    }
    
    var request = new Request(params);
    this.lastRequest = request;
    $(that).trigger('ihBeforeRequestPlaces', [request]);
    
    return this._search(request).then(function(res){
      if (request.get('order')){
        var placeIds = request.get('order');
        // resは順不同なのでリクエストしたplacesIdの順序に並べ替える
        var places = [];
        var map = {};
        _.each(res.places, function(place, k){
          map[place.id] = place;
        })
        _.each(placeIds, function(v, k){
          places.push(that.placeDataFilter(map[v]));
        });
        res.places = places;
      }else{
        that.map.displayCircle(that.getRadius());
        if (that.arrangePlaces){
          res.places = that.arrangePlaces(res.places);
        }
      }

      var places = _.filter(res.places, function(place){
        return !!place;
      });
      $(that).trigger('ihAfterRequestPlaces', [request, places]);
      return res;
    }).catch(function(err) {
      console.warn(err);
      that.displayLoading(false);
      // that.map.displayCircle(that.getRadius());
    });
  }
  /**
   * 前回の検索設定で再検索する
   * 
   */
  reSearch(params) {
    if (!this.lastRequest){
      return;
    }
    var that = this;
    var request = this.lastRequest.extend(params);
    
    $(that).trigger('ihBeforeRequestPlaces', [request]);
    
    return this._search(request).then(function(res){
      if (request.get('order')){
        var placeIds = request.get('order');
        // resは順不同なのでリクエストしたplacesIdの順序に並べ替える
        var places = [];
        var map = {};
        _.each(res.places, function(place, k){
          map[place.id] = place;
        })
        _.each(placeIds, function(v, k){
          places.push(that.placeDataFilter(map[v]));
        });
        res.places = places;
      }else{
        that.map.displayCircle(that.getRadius());
        if (that.arrangePlaces){
          res.places = that.arrangePlaces(res.places);
        }
      }
      // lastClickedPlaceの情報を更新（距離が変わる）
      var lp = that.getLastClickedPlace();
      _.each(res.places, function(place){
        if (place && lp && place.id === lp.id){
          that.lastClickedPlace = place;
        }
      });

      $(that).trigger('ihAfterRequestPlaces', [request, res.places]);
      return res;
    }).catch(function() {
      that.displayLoading(false);
      that.map.displayCircle(that.getRadius());
    });
  }
  /**
   * 
   * @returns {jQuery.Deferred}
   */
  searchFromCenter() {
    /**
     * 地図の中心点から検索する
     */
    var c = this.map.getCenter();

    this.search_method_prev_num = 0;

    // マーカーの読み込み
    return this.requestPlaces({
      lat: c.lat(),
      lng: c.lng(),
      radius: this.getRadius(),
      types: this.getSearchTargetTypes()
    });
  }
  /**
   * 基準位置を中心に検索
   * @returns {unresolved}
   */
  searchFromBaseMarker(){
    
    var c = this.map.getCurrentSearchLocation();
    
    return this.requestPlaces({
      lat: c.lat(),
      lng: c.lng(),
      radius: this.getRadius(),
      types: this.getSearchTargetTypes()
    });
  }
  /**
   * 半径を変更
   *
   * @param {String} radius
   * @returns {String}
   */
  setRadius(radius) {
    this.selected_radius = radius; // radiusは文字列型
    return radius;
  }
  getRadius(){
    return this.selected_radius;
  }
}

module.exports = IH;


// WEBPACK FOOTER //
// ./map/js/ih/z.core.js